/**
 * The print window (router 'print' and 'printVersion') always renders in light mode.
 * Dark mode inverted every printed page and swapped black notes to white, so people
 * who work in dark mode printed near-black pages (found 11 Oct 2026, fixed for Sun 18).
 */
const PRINT_PATH = /^\/project\/[^/]+\/(version\/[^/]+\/)?print\/[^/]+\/?$/;

export default function isPrintPath(pathname) {
    return typeof pathname === 'string' && PRINT_PATH.test(pathname);
}


// WEBPACK FOOTER //
// ./src/lib/print-route.js